export default {"src":"/_next/static/media/DeepMode.ed314dbe.svg","height":40,"width":177,"blurWidth":0,"blurHeight":0};